import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { Creators as MessagesCreators } from '../../store/ducks/messages';

const URLFilter = ({
  location, children, setMessage, privateURLs,
}) => {
  const path = location.pathname;

  privateURLs.push({ path: '/credit-card' });

  if (!window.localStorage.getItem('authToken') && privateURLs.find(url => url.path === path)) {
    setMessage('Você precisa fazer login para continuar.', 'warning', true);
    return <Redirect to="/signin" />;
  }

  if (window.localStorage.getItem('authToken') && ['/signin'].includes(path)) {
    return <Redirect to="/" />;
  }

  if (window.localStorage.getItem('authToken') && ['/signup'].includes(path)) {
    // descomentar qnd o cartão entrar em produção e apagar a linha abaixo
    // return <Redirect to="/credit-card" />;
    return <Redirect to="/" />;
  }

  return children;
};

URLFilter.propTypes = {
  location: PropTypes.shape().isRequired,
  children: PropTypes.element.isRequired,
  setMessage: PropTypes.func.isRequired,
  privateURLs: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

const mapStateToProps = state => ({
  ...state.sessions,
});

const mapDispatchToProps = dispatch => bindActionCreators(MessagesCreators, dispatch);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(URLFilter));



// WEBPACK FOOTER //
// ./src/components/URLFilter/index.js